import Styles from './FixEmail.scss';

import Template from './FixEmail.hbs';
import Util from 'util/util';
import EmailInput from 'views/components/quickInput/emailInput/EmailInput';
import saveEmail from './saveEmail';

export default class FixEmail extends BaseView {

    initialize({
        email,
        studentId = '',
        groupId,
        parent,
    }) {

        _.bindAll(
            this,
            'onClickSendLogin'
        );

        var strippedEmail = Util.stripTags(email);

        this.studentId = studentId
        this.groupId = groupId

        this.parent = parent

        // Create the view, passing the styling with it
        this.setElement(Template({
            Styles,
            email: strippedEmail,
            isTeacherFixingStudent: !!this.studentId
        }));

        // Add a childview
        this.emailInput = this.addChildView(new EmailInput({
            defaultValue: strippedEmail,
            autoFocus: true,
            emailCallback: this.onClickSendLogin
        }), '.js-input-field');

    }

    addButtons() {
        var buttons = {};

        buttons[window.i18n.gettext('Cancel')] = {
            callback: Backbone.View.Components.modal.close,
            theme: 'secondary'
        };

        buttons[window.i18n.gettext('Resend login information')] = {
            // Set callback to the onClickSendLogin method within the subview
            callback: this.emailInput.triggerInputCallback,
        };

        Backbone.View.Components.modal.addButtons(buttons, true);
    }

    async onClickSendLogin(input) {
        const result = await saveEmail(input, this.studentId)

        if (result === 'saved') {

            // If there is no student id nor group id passed
            if (!this.studentId && !this.groupId) {

                // This means the user is fixing his own email
                // Therefore set change his email in the user model
                Backbone.Model.user.set({
                    email: input
                });

                // Else this is a teacher who holds a collection of
                // students with no credentials.
            } else {

                //  Remove this student through his id.
                this.collection.remove(this.studentId);

                // Destroy related pending action view
                this.parent.destroy();

            }

            Backbone.View.Components.modal.close();
        } else if (result === 'already-valid') {

            // If this modal is used by a teacher with a collection of
            // students without credentials
            if (this.collection && this.studentId) {

                // Remove the student from the collection so the
                // related pending action will be removed
                this.collection.remove(this.studentId);
            }
            Backbone.View.Components.modal.close();
        }

    }

}
